import { AvatarDropdown as CoreAvatarDropdown, useSession } from '@zhiyue/core';
import { Avatar } from 'antd';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown = () => {
  const { currentUser } = useSession();
  const currentMemberLabel = React.useMemo(() => {
    return currentUser?.nickname || currentUser?.username || '-';
  }, [currentUser?.nickname, currentUser?.username]);

  const avatarFallback = React.useMemo(() => {
    const normalizedLabel = currentMemberLabel?.trim();
    const chars = Array.from(normalizedLabel || '');

    return (chars.slice(-2).join('') || 'U').toUpperCase();
  }, [currentMemberLabel]);

  return (
    <CoreAvatarDropdown
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      openPlatformUrl={BizAppConfig.appOpenPlatformUrl}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
        }}
      >
        <Avatar size={22} src={currentUser?.avatar}>
          {avatarFallback}
        </Avatar>
        <span>{currentMemberLabel}</span>
      </div>
    </CoreAvatarDropdown>
  );
};

export default AvatarDropdown;
